function setTrackingAttributes(element, category, location, action = '', label = '') {
  let linkPath = '';
  if(label !== '') {
    linkPath = label;
  } else if(element.href) {
    linkPath = element.href.replace(window.location.origin, '');
  }

  if(action === '') {
    action = 'Click ' + element.textContent;
  }

  element.setAttribute('data-elCat', category);
  element.setAttribute('data-elAct', action);
  if(linkPath !== '') {
    element.setAttribute('data-elLab', linkPath);
  }
  element.setAttribute('data-elLoc', location);
}

export default setTrackingAttributes;